import type { FC } from 'react'
import type { RangeSliderProps } from '@chakra-ui/react'
import {
  Box,
  RangeSlider,
  RangeSliderFilledTrack,
  RangeSliderThumb,
  RangeSliderTrack
} from '@chakra-ui/react'
import { BiCircle } from 'react-icons/bi'
import { useUIGlobalsContext } from 'ui/lib/ui-globals/hooks'

type IRangeFilterItemProps = RangeSliderProps

export const RangeFilterItem: FC<IRangeFilterItemProps> = ({ step, ...props }) => {
  const { priceRangeStep } = useUIGlobalsContext()
  const stepValue = step ?? priceRangeStep ?? 50

  return (
    <RangeSlider
      aria-label={['min', 'max']}
      flexGrow={1}
      focusThumbOnChange={false}
      step={stepValue}
      {...props}
    >
      <RangeSliderTrack bg="brand.darkExtraLight">
        <RangeSliderFilledTrack bg="background.overlay" />
      </RangeSliderTrack>
      <RangeSliderThumb bg="primary" boxSize={6} index={0}>
        <Box as={BiCircle} color="text.light" />
      </RangeSliderThumb>
      <RangeSliderThumb bg="primary" boxSize={6} index={1}>
        <Box as={BiCircle} color="text.light" />
      </RangeSliderThumb>
    </RangeSlider>
  )
}
